import * as React from 'react'
import { ActivityIndicator, View } from 'react-native'
import styles from './styles'

export function LoadingCard() {
  return (
    <View
      style={[
        styles.innerCard,
        {
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 115,
        },
      ]}
    >
      <ActivityIndicator />
    </View>
  )
}
